import React from "react";
import { formatCertificateDate } from "../lib/certificates";

export default function CertificatePreview({ title, type, recipientName, recipientRole, citation, awarderName, awarderRole, awardedOn, certificateNumber }) {
  return (
    <div className="ruht-certificate-preview" aria-label="Certificate preview">
      <div className="ruht-certificate-preview__inner">
        <div className="ruht-certificate-preview__masthead"><strong>RUHT</strong><span>STAFF RECOGNITION<br/><small>OFFICIAL CERTIFICATE RECORD</small></span></div>
        <div className="ruht-certificate-preview__body">
          <h3>{title || "Certificate of Recognition"}</h3>
          <div className="ruht-certificate-preview__type">{type || "Recognition"}</div>
          <div className="ruht-certificate-preview__presented">Presented to</div>
          <div className="ruht-certificate-preview__recipient">{recipientName || "Staff member"}</div>
          <div className="ruht-certificate-preview__role">{recipientRole || "RUHT staff"}</div>
          <div className="ruht-certificate-preview__rule" />
          <p>{citation || "Your award citation will appear here."}</p>
          <div className="ruht-certificate-preview__signatures">
            <div><strong>{awarderName || "RUHT Management"}</strong><span>Awarded by</span><small>{awarderRole || "Management"}</small></div>
            <div><strong>{awardedOn ? formatCertificateDate(awardedOn) : "Award date"}</strong><span>Date awarded</span></div>
          </div>
        </div>
        <div className="ruht-certificate-preview__footer"><strong>{certificateNumber || "Certificate number assigned on issue"}</strong><span>Issued through RUHT Cloud</span></div>
      </div>
    </div>
  );
}
